var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("\n        Удалить кейс "+_vm._s(_vm.delData.name.ru)+" № "+_vm._s(_vm.delData.id)+"?\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",staticStyle:{"position":"absolute","bottom":"10px"},on:{"click":_vm.deleteCase}},[_vm._v("\n        подтвердить\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbb2a53c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/deleteCase.vue
// module id = 353
// module chunks = 0